import React, { useEffect, useState } from 'react';
import { Dialog, Box, Typography, DialogTitle, IconButton, TextField, Button, DialogContent, DialogActions, Backdrop, CircularProgress } from '@material-ui/core';
import { Close, Star } from '@material-ui/icons';
import { Alert, Rating } from '@material-ui/lab';
import axios_instance from '../services/auth/jwt/config';
import sweetAlert from './utils/sweetAlert';
import ModalFullLSE from './utils/ModalFullLSE';

interface AvaliarSistemaDialogProps {
}

export default function AvaliarSistemaDialog({ }: AvaliarSistemaDialogProps) {
    const [open, setOpen] = useState(false);
    const [titulo, setTitulo] = useState('Avaliar Sistema');
    const [descricao, setDescricao] = useState('Sua opinião é muito importante para nós! Por favor, avalie o sistema e nos ajude a melhorar cada vez mais.');
    const [pergunta, setPergunta] = useState('Como você avalia o sistema?');
    const [grupoId, setGrupoId] = useState<number | null>(null);
    const [nota, setNota] = useState<number | null>(0);
    const [comentario, setComentario] = useState('');
    const [hover, setHover] = useState(-1);
    const [success, setSuccess] = useState({ has: false, message: '' })
    const [loading, setLoading] = useState({ is: false, message: '' })
    const [error, setError] = useState({ has: false, message: '' })

    const labels: { [index: string]: string } = {
        1: 'Muito Ruim',
        2: 'Ruim',
        3: 'Regular',
        4: 'Bom',
        5: 'Excelente',
    };

    useEffect(() => {
        axios_instance.get<{ success: boolean, grupo_id: number, titulo: string, descricao: string, pergunta: string }>(`/avaliacao/sistema/usuario-pode-avaliar`).then((response) => {
            let r = response.data
            if (r.success) {
                setOpen(true);
                setGrupoId(r.grupo_id);
                setTitulo(r.titulo);
                setDescricao(r.descricao);
                setPergunta(r.pergunta);
            }
        }).catch(() => {

        })
    }, [])

    const onClose = () => {
        setOpen(false);
    }

    const handleSubmit = () => {
        if (nota && nota > 0) {
            setLoading({ is: true, message: 'Enviando sua avaliação...' });
            axios_instance.post<{ success: boolean }>(`/avaliacao/sistema/avaliar`, {
                nota: nota,
                observacao: comentario,
                grupo_id: grupoId
            }).then((response) => {
                let r = response.data;
                if (r.success) {
                    setSuccess({ has: true, message: 'Obrigado por avaliar o sistema! Sua opinião é muito importante para nós.' });
                } else {
                    setError({ has: true, message: 'Houve um erro ao enviar sua avaliação. Por favor, tente novamente mais tarde.' });
                }
            }).catch(() => {
                setError({ has: true, message: 'Houve um erro ao enviar sua avaliação. Por favor, tente novamente mais tarde.' });
            }).finally(() => {
                setLoading({ is: false, message: '' });
            })
        }
    };

    const handleClose = (done = false) => {
        setLoading({ is: false, message: '' });
        setSuccess({ has: false, message: '' });
        setError({ has: false, message: '' });
        if (done) {
            setNota(0);
            setComentario('');
            setHover(-1);
            onClose();
        }
    };

    const getLabelText = (value: number) => {
        return `${value} Estrela${value !== 1 ? 's' : ''}, ${labels[value]}`;
    };

    return (
        <Dialog
            open={open}
            onClose={() => onClose()}
            maxWidth="md"
            fullWidth
        >
            <ModalFullLSE
                error={error}
                loading={loading}
                success={success}
                onDone={handleClose}
            />
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {titulo}
                    <IconButton
                        aria-label="fechar"
                        onClick={() => onClose()}
                    >
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: "center", gridGap: 2, py: 1 }}>
                    {descricao ? <Alert severity="info">
                        <Typography variant="body1" align="center">
                            {descricao}
                        </Typography>
                    </Alert> : null}

                    <Box sx={{ my: 2, alignItems: 'center', textAlign: 'center' }}>
                        <Typography variant="h6" component="legend" gutterBottom>
                            {pergunta}
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gridGap: 2
                            }}
                        >
                            <Rating
                                name="avaliacao-sistema"
                                value={nota}
                                precision={1}
                                size="large"
                                getLabelText={getLabelText}
                                onChange={(event, newValue) => {
                                    setNota(newValue);
                                }}
                                onChangeActive={(event, newHover) => {
                                    setHover(newHover);
                                }}
                                emptyIcon={<Star style={{ opacity: 0.3 }} fontSize="inherit" />}
                            />
                        </Box>
                        <Typography variant="body2" color="secondary">
                            {nota !== null ? labels[hover !== -1 ? hover : nota] : '-'}
                        </Typography>
                    </Box>

                    <TextField
                        label="Comentários (opcional)"
                        multiline
                        minRows={4}
                        fullWidth
                        variant="outlined"
                        value={comentario}
                        onChange={(e) => setComentario(e.target.value)}
                        placeholder="Conte-nos mais sobre sua experiência com o sistema..."
                        inputProps={{
                            maxLength: 500
                        }}
                        helperText={`${comentario.length}/500 caracteres`}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!nota || nota === 0}
                    color="primary"
                >
                    Enviar Avaliação
                </Button>
            </DialogActions>
        </Dialog>
    );
}
